import { render, staticRenderFns } from "./NxtRedirectionModal.vue?vue&type=template&id=0e88b706&"
import script from "./NxtRedirectionModal.vue?vue&type=script&lang=js&"
export * from "./NxtRedirectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports